import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
import Loader from "../../shared/loader";
import Pagination from "../../shared/pagination";

const MyProduct = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [seriesDrp, setSeriesDrp] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productCount, setProductCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const debounceTimeout = useRef(null);
  const itemsPerPage = 30;

  const [formData, setFormData] = useState({
    size_id: null,
    series_id: null,
  });

  const getProduct = (page = 1) => {
    setLoading(true);
    axios
      .post(API_URL.MY_PRODUCT_LIST, {
        name: searchText,
        series_id: formData.series_id,
        size_id: formData.size_id,
        page: page,
        limit: itemsPerPage,
      })
      .then(
        (res) => {
          if (res.data.status === 1) {
            setProductData(res.data.data.data);
            const total = res.data.data.total || 0;
            setTotalPages(Math.ceil(total / itemsPerPage));
            setProductCount(total);
          }
          setIsLoaded(true);
          setLoading(false);
        },
        () => {
          setLoading(false);
          toast.error("Something went wrong..", { autoClose: 3000 });
        }
      );
  };

  const getSizeDrpData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      let cd = res.data.data.map((caw) => ({
        label: caw.name,
        value: caw.id,
      }));
      setSizeDrpData(cd);
    });
  };
  
  const getSeries = () => {
    axios.post(API_URL.SERIES_LIST, {}).then((res) => {
      let cd = res.data.data.map((caw) => ({
        label: caw.name,
        value: caw.id,
      }));
      setSeriesDrp(cd);
    });
  };

  const deletProduct = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.MY_PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              toast.success(row.name + " deleted successfully", { autoClose: 3000 });
              getProduct(currentPage); // reload current page
            }
            setLoading(false);
          },
          () => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const styles = {
    menu: (baseStyles) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  useEffect(() => {
    getProduct(currentPage);
    getSizeDrpData();
    getSeries();
  }, []);

  useEffect(() => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      if (isLoaded) {
        setCurrentPage(1); 
        getProduct(1);
      }
    }, 500);

    return () => clearTimeout(debounceTimeout.current);
  }, [searchText]);

  useEffect(() => {
    if (isLoaded) {
      setCurrentPage(1); 
      getProduct(1);
    }
  }, [formData.size_id, formData.series_id]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getProduct(page);
  };

  return (
    <>
      <div className={`row`}>
        <div className="col-2">
          <h1>
            Product <small className="me-2">({productCount})</small>
          </h1>
        </div>
        <div className="col-10">
          <div className="d-flex align-items-center justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <input type="text" className="form-control" placeholder="Search by name" value={searchText}  onChange={(e) => setSearchText(e.target.value)}/>
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Series"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={seriesDrp}
                isClearable
                value={seriesDrp.find((r) => r.value == formData.series_id)}
                styles={styles}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    series_id: (e) ? e.value : null,
                  });
                }}
              />
            </div>
            <div className="form-group mb-0 mr-2" style={{ width: 250 }}>
              <Select
                placeholder="Select Size"
                className="form-control-sm"
                style={{ border: "1px solid lightgray" }}
                options={sizeDrp}
                isClearable
                value={sizeDrp.find((r) => r.value == formData.size_id)}
                styles={styles}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    size_id: (e) ? e.value : null,
                  });
                }}
              />
            </div>
            <Link to={"/my-products/add"} className="btn btn-primary">
                Add Product
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
            <div className="card">
              <div className="card-body p-0">
                {loading && <Loader />}
                {!loading && (
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          {/* <th>Image</th> */}
                          <th>Name</th>
                          <th>Price</th>
                          <th>In Stock</th>
                          <th>Category</th>
                          <th>Size</th>
                          <th style={{ width: "300px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productData.map((row, key) => (
                          <tr key={key}>
                            <td>{(currentPage - 1) * itemsPerPage + key + 1}</td>
                            {/* <td className="table-avatar">
                              <div
                                style={{
                                  backgroundImage: "url(" + row.image + ")",
                                  height: 50,
                                  width: 50,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                }}
                              ></div>
                            </td> */}
                            <td>{row.name}</td>
                            <td>{row.price}</td>
                            <td>
                              {(row.subproducts.length > 0) ?
                                row.subproducts.map((subproduct) => {
                                  return (
                                    <div key={subproduct.id}>
                                      {subproduct.subproduct?.name} - {subproduct.in_stock}
                                    </div>
                                  )
                                }) :
                                row.in_stock
                              }
                            </td>
                            <td>{row.category_name}</td>
                            <td>{row.size_name}</td>
                            <td className="d-flex">
                              <Link to={`/my-products/edit/${row.id}`} className="btn btn-sm btn-secondary mr-2">
                                Edit
                              </Link>
                              <button onClick={() => deletProduct(row)} className="btn btn-sm btn-danger">
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {totalPages > 1 && (
                      <div className="d-flex justify-content-center my-3">
                        <Pagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
        </div>
      </div>
    </>
  );
};

export default MyProduct;
